import PUBLIC_ROUTES from '../constants/ConstPublicRoutes';

const determineAnimation = (nextRoute: string) => {
  const nextRouteIndex = PUBLIC_ROUTES.findIndex(r => r.path === nextRoute);
  const currentRouteIndex = PUBLIC_ROUTES.findIndex(r => r.path === window.location.pathname);
  return nextRouteIndex >= currentRouteIndex ? 'next' : 'previous';
};
export default determineAnimation;
